import { Dialog, DialogContent, DialogTrigger } from "../../components/ui/dialog";
import { LeadForm } from "./LeadForm";
import { ReactNode } from "react";

interface LeadFormDialogProps {
  children: ReactNode;
}

export const LeadFormDialog = ({ children }: LeadFormDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <LeadForm />
      </DialogContent>
    </Dialog>
  );
};
